import api from './api';

/** Option values of the Zendesk "Technology | Request Type" field. */
export type HelpdeskRequestType = 'incident' | 'service_request' | 'access_request' | 'change_request';

export interface HelpdeskTicketData {
  title: string;
  description: string;
  request_type: HelpdeskRequestType;
  page_url?: string;
  screenshot_url?: string;
  uploaded_images?: string[];
  additional_info?: Record<string, any>;
}

export interface HelpdeskTicketResponse {
  id: number;
  /** IT Support Help Center request page for the new ticket. */
  url: string;
  title: string;
  status: string;
  created_at?: string;
  message: string;
}

export interface HelpdeskTicketConfig {
  enabled: boolean;
  request_types: { value: HelpdeskRequestType; label: string }[];
}

const helpdeskTicketsService = {
  /**
   * Submit a computer-support ticket. Same Zendesk account as bugs and
   * features, but routed to the IT Support brand/group and tagged `helpdesk`.
   */
  async submitHelpdeskTicket(data: HelpdeskTicketData): Promise<HelpdeskTicketResponse> {
    const response = await api.post('/helpdesk-tickets/submit', data);
    return response.data;
  },

  async getConfig(): Promise<HelpdeskTicketConfig> {
    const response = await api.get('/helpdesk-tickets/config');
    return response.data;
  },
};

export default helpdeskTicketsService;
